"use strict";

import Vue from 'vue';
import axios from "axios";
import {Message, Notification} from 'element-ui';
import {getToken} from "@/utils/auth";
import {SUMMARY_NO_PERMISSION} from "@/config/business/code";
import router from '@/router'

const _axios = axios.create();
let IS_LOGIN_EXPIRED = false // 登录过期标识

// console.log(AUTH_TOKEN)
// _axios.defaults.headers.common['Authorization'] = 'Bearer '+ AUTH_TOKEN;
_axios.interceptors.request.use(
    function (config) {
        let token = getToken();
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        config => {
            config.baseURL = '/api/'
            config.withCredentials = true // 允许携带token ,这个是解决跨域产生的相关问题
            config.timeout = 6000
            config.headers = {
                'Content-Type': 'application/json'
            }
        }
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject('【request reject】' + error.message);
    }
);

// Add a response interceptor
_axios.interceptors.response.use(
    response => {
        const contentType = response.headers['content-type']
        if (contentType.indexOf('application/json') > -1) {
            if (response.data.size) {
                return response.data
            } else {
                if (response.data.success) {
                    return response.data;
                } else if (response.data.code === SUMMARY_NO_PERMISSION) {
                    window.location = '/dashboard?disable=1'
                    return Promise.reject('【response reject】' + response.data.message);
                } else {
                    Message.warning({
                        title: '提示',
                        message: response.data.message || '请求失败，请稍后重试'
                    });

                    return response.data;
                    // return Promise.reject(response.data.message);
                }
            }
        } else {
            return response
        }
    },
    error => {
        // Do something with response error
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    if (!IS_LOGIN_EXPIRED) {
                        Notification.error({
                            title: '登录过期提醒',
                            message: '授权验证失败，请重新登录'
                        });
                    }
                    IS_LOGIN_EXPIRED = true
                    // Router.replace({path: '/login'})
                    localStorage.clear()
                    router.push({path: `/login?redirect=${router.app._route.fullPath}`})

                    // window.location = '/login'
                    break;
                case 402:
                    Notification.error({
                        title: '402',
                        message: '权限不足'
                    });
                    break;
                case 403:
                    Notification.error({
                        title: 'Forbidden',
                        message: 'data.message'
                    });
                    break;
                case 429:
                    Message.warning({
                        title: '提示',
                        message: '请求太频繁，请稍后尝试'
                    });
                    // Notification.error({
                    //     title: '429',
                    //     message: '请求太频繁，请稍后尝试'
                    // });
                    break;
                case 500:
                    Notification.error({
                        title: '500',
                        message: '服务器开小差，请稍后重试'
                    });
                    break;

            }
        }
        return Promise.reject('【response reject】' + error.message);
    }
);
// eslint-disable-next-line
Plugin.install = function (Vue, options) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            }
        },
        $axios: {
            get() {
                return _axios;
            }
        },
    });
};

/**
 * 封装post请求
 * @param {*} url 请求路径
 * @param {*} params 参数
 * @returns {Promise}
 */
export function getBlob(url, params) {
    params['_t'] = Math.random()
    return new Promise((resolve, reject) => {
        _axios({
            method: 'get',
            url,
            params: params,
            responseType: 'blob'
        }).then(response => {
            resolve(response)
        }).catch(err => {
            if (typeof (err.code) === 'undefined') {
                return reject('【getBlob reject】' + err.message);
            }
        })
    })
}

/**
 * 封装post请求
 * @param {*} url 请求路径
 * @param {*} params 参数
 * @returns {Promise}
 */
export function postBlob(url, params) {
    params['_t'] = Math.random()
    return new Promise((resolve, reject) => {
        _axios({
            method: 'post',
            url,
            data: params,
            responseType: 'blob'
        }).then(response => {
            resolve(response)
        }).catch(err => {
            if (typeof (err.code) === 'undefined') {
                reject('【postBlob reject】' + err.message);
            }
        })
    })
}

/**
 *
 * @param url
 * @param params
 * @returns {Promise<unknown>}
 */
export function postArrayBuffer(url, params) {
    return new Promise((resolve, reject) => {
        _axios({
            method: 'post',
            url,
            data: params,
            responseType: 'arraybuffer'
        }).then(response => {
            resolve(response)
        }).catch(err => {
            if (typeof (err.code) === 'undefined') {
                reject('【postArrayBuffer reject】' + err.message);
            }
        })
    })
}

Vue.use(Plugin)

// export default Plugin;
